const CustomArea = ({ placeholder, type, value, onChange, name = "" }) => {
  return (
    <textarea
      className="h-[100px] w-full text-[13px] rounded-[2px] px-[10px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9]"
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      name={name}
    />
  );
};

export default CustomArea;
